import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function misattribution () {
	const section = document.querySelector('.misattribution');
	if (! section) return;

	const bar = section.querySelector('.nav-cover-bar');
	if (! bar) return;

	const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	if (reduce) {
		bar.classList.add('is-fixed');
		return;
	}

	// Lock the bar once it has risen to the header, not while it is still
	// short of the top — fixing it early snaps it up and the logo jitters.
	const meet = () => {
		const pad = parseFloat(getComputedStyle(section).paddingTop) || 0;
		const pull = Math.abs(parseFloat(getComputedStyle(bar).marginTop) || 0);
		const stick = parseFloat(getComputedStyle(bar).top) || 0;
		return Math.max(0, stick + pull - pad);
	};

	ScrollTrigger.create({
		trigger: section,
		start: () => 'top ' + meet() + 'px',
		end: 'bottom top',
		onToggle: (self) => bar.classList.toggle('is-fixed', self.isActive),
	});

	ScrollTrigger.refresh();
}
